import { createReducer, on } from '@ngrx/store';
import * as chatActions from '../actions/chat.action';
import { initialState } from '../../models/chat.state';

export const chatReducer = createReducer(
  initialState,
  on(chatActions.loadChat, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(chatActions.loadChatSuccess, (state, { messages }) => ({
    ...state,
    loading: false,
    messages: [...messages, ...state.failedMessages], 
    currentMessage: null,
    error: null
  })),
  on(chatActions.loadChatFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error
  })),
  on(chatActions.sendMessage, (state, { message }) => ({
    ...state,
    currentMessage: { ...message, isSending: true },
    messages: [...state.messages, { ...message, pending: true }], 
    error: null
  })),
  on(chatActions.sendMessageSuccess, (state) => ({
    ...state,
    messages: state.messages.map(message => 
      message.id === state.currentMessage?.id ? { ...message, pending: false, messageSent: true } : message
    ),
    failedMessages: state.failedMessages.filter(message => message.id !== state.currentMessage?.id), 
    error: null
  })),
  on(chatActions.sendMessageFailure, (state, { error }) => ({
    ...state,
    loading: false,
    messages: state.messages.map(message => 
      message.id === state.currentMessage?.id ? { ...message, pending: false, messageSent: false, failed: true } : message
    ),
    failedMessages: [...state.failedMessages, { ...state.currentMessage, pending: false, messageSent: false, failed: true }], 
    error: error
  })),
  on(chatActions.getMediaUploadUrl, state => ({
    ...state,
    loading: true,
    error: null, 
  })),
  on(chatActions.getMediaUploadUrlSuccess, (state, { mediaUploadDetails }) => ({
    ...state,
    loading: false,
    mediaUploadUrl: mediaUploadDetails,
    error: null
  })),
  on(chatActions.getMediaUploadUrlFailure, (state, { error }) => ({
    ...state,
    loading: false,
    messages: state.messages.map(message => 
      message.id === state.currentMessage?.id ? { ...message, pending: false, messageSent: false, failed: true } : message
    ),
    failedMessages: [...state.failedMessages, { ...state.currentMessage, pending: false, messageSent: false, failed: true }], 
    error: error
  })),
  on(chatActions.updateMediaMessage, (state, { mediaMessage, file }) => ({
    ...state,
    currentMessage: { ...mediaMessage, isSending: true },
    messages: [...state.messages, { ...mediaMessage, pending: true }], 
    mediaMessage: mediaMessage,
    mediaFile: file,
    isLoading: false,
    error: null
  })),
  on(chatActions.sendMediaMessageSuccess, (state, { mediaMessage }) => ({
    ...state,
    loading: false,
    messages: state.messages.map(message => 
      message.id === mediaMessage.id ? { ...message, messageSent: true, pending: false } : message
    ),
    failedMessages: state.failedMessages.filter(message => message.id !== mediaMessage.id), 
    error: null
  })),
  on(chatActions.sendMediaMessageFailure, (state, { error }) => ({
    ...state,
    loading: false,
    messages: state.messages.map(message => 
      message.id === state.currentMessage?.id ? { ...message, pending: false, messageSent: false, failed: true } : message
    ),
    failedMessages: [...state.failedMessages, { ...state.currentMessage, pending: false, messageSent: false, failed: true }], 
    error: error
  })),
  on(chatActions.startSseConnection, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(chatActions.startSseConnectionSuccess, state => ({
    ...state,
    loading: false,
    error: null
  })),
  on(chatActions.startSseConnectionFailure, state => ({
    ...state,
    loading: false,
    error: null
  })),
  on(chatActions.receiveMessage, (state, { service_id }) => {
    const existingPendingMessage = state.pendingMessages.find(
      (msg) => msg.service_id === service_id
    );

    let updatedPendingMessages;
    if (existingPendingMessage) {
      updatedPendingMessages = state.pendingMessages.map((msg) =>
        msg.service_id === service_id
          ? { ...msg, count: msg.count + 1 }
          : msg
      );
    } else {
      updatedPendingMessages = [
        ...state.pendingMessages,
        { service_id, count: 1 },
      ];
    }

    return {
      ...state,
      pendingMessages: updatedPendingMessages,
    };
  }),

  on(chatActions.clearMessageRead, (state, { service_id }) => {
    const updatedPendingMessages = state.pendingMessages.filter(
      (msg) => msg.service_id !== service_id
    );
  
    return {
      ...state,
      pendingMessages: updatedPendingMessages,
    };
  }),
);
